import { Icon } from "@chakra-ui/react";
const MobileRedIcon = () => {
  return (
    <>
      <Icon
        xmlns="http://www.w3.org/2000/svg"
        width="15.125"
        height="22"
        viewBox="0 0 15.125 22"
      >
        <path
          id="red"
          d="M4,3.75A2.753,2.753,0,0,1,6.75,1h9.625a2.753,2.753,0,0,1,2.75,2.75v16.5A2.753,2.753,0,0,1,16.375,23H6.75A2.753,2.753,0,0,1,4,20.25Zm8.938,16.5a1.375,1.375,0,1,0-.4.972A1.375,1.375,0,0,0,12.938,20.25Zm3.438-16.5H6.75V17.5h9.625Z"
          transform="translate(-4 -1)"
          fill="red"
        />
      </Icon>
    </>
  );
};
export default MobileRedIcon;
